import { render, staticRenderFns } from "./AttachmentPopUp.vue?vue&type=template&id=47066d3e&scoped=true"
import script from "./AttachmentPopUp.vue?vue&type=script&lang=js"
export * from "./AttachmentPopUp.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPopUp.vue?vue&type=style&index=0&id=47066d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47066d3e",
  null
  
)

export default component.exports